import { AdContentUpdate } from "./ad-content-update.model";
import { OrderAdDetailUpdate } from "./order-ad-detail-update.model";
import { OrderContactDetails } from "./order-contact-details.model";
import { OrderServiceUpdate } from "./order-service-update";

export class OrderUpdate {
	id?: string;
	verificationCode?: string;
	orderAdDetailUpdates?: OrderAdDetailUpdate[];
	adContentUpdates?: AdContentUpdate[];
	orderServiceUpdates?: OrderServiceUpdate[];
	campaignName?: string;
	invoiceDescription?: string;
	contactDetails?: OrderContactDetails;
	advertiserId?: string;
	otherPayerId?: string;
	subscriberNumber?: string;
	requestStatus?: string
	advertiserRefNumber?: string
	materialAgencyName?: string;
	materialContactFirstName?: string;
	materialContactLastName?: string;
	materialContactEmail?: string;
	materialContactPhone?: string;
	externalPlanId?: string;
}
